"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createDeviceChangeObserver = require("./createDeviceChangeObserver");
Object.keys(_createDeviceChangeObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createDeviceChangeObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createDeviceChangeObserver[key];
    }
  });
});